import type { ReactElement } from 'react';
import { Icon } from '@pixum/icon';
import { PAYMENT_CARD_ICON_NAME } from '../../payment/constants';
import type { CreditCardType } from '../../payment/types';

/** Brand logos keep their own colours, so no CSS mask. */
export function getCreditCardIcon(type: CreditCardType): ReactElement {
  return <Icon key={type} name={PAYMENT_CARD_ICON_NAME[type]} useMask={false} ariaHidden size="large" />;
}
